import { z } from "zod";
export const updateStripeIntegrationSchema = z.object({
    secret_key: z.string().min(1),
    publishable_key: z.string().min(1),
    webhook_secret: z.string().min(1),
});
